<div class="ttmodal">

    <div class="ttmodal__header">
        <span class="ttmodal__title">Asset Rebuild</span>
        <i class="material-icons ttmodal__close-button" (click)="onCloseClick()">close</i>
    </div>

    <mat-tab-group  [(selectedIndex)]="selectedTab"   (selectedIndexChange)="LoadData(selectedTab)" *ngIf="CycleDetails !=null">
        <mat-tab label="Asset Rebuild">
            <div class="ttmodal__body">
                <div style="display: flex;">
                    <div class="input-container">
                        <span class="label">Asset</span>
                        <span class="label" style="    margin-left: -5px">{{implementName}}</span>
                    </div>
            
                    <div class="input-container">
                        <span class="label" style="margin-left: 113px;">Status</span>
                        <span class="label" style="margin-left: -74px;">{{status}}</span>
                    </div>
                </div>
                
        
                <div style="display: flex;">
                    <div class="input-container">
                        <span class="label">Repairer</span>
                        <div>
                            <select class="margin-right-8 get-Input" [(ngModel)]="selectedRepairerId" (change)="repairerSelected($event.target.value)" >
                                <option value="" disabled selected>Select Repairer</option>
                                <option *ngFor="let repairer of repairerList" [value]="repairer.Id">{{repairer.Name}}</option>
                            </select>
                            <button mat-icon-button (click)="addRepairer()">
                                <mat-icon>add</mat-icon>
                            </button>
                        </div>
                    </div>
            
                    <div class="input-container" >
                        <span class="label" style="margin-left: 30px;" >Location</span>
                        <div>
                            <select class="margin-right-8 get-Input" style="margin-left: -55px;" [(ngModel)]="selectedWorkshopId" (change)="workshopSelected($event.target.value)">
                                <option value="" disabled selected>Select Location</option>
                                <option *ngFor="let workshop of workshopList" [value]="workshop.Id">{{workshop.Name}}</option>
                            </select>
                            <button mat-icon-button (click)="addWorkshop()"  *ngIf="showAddWorkshop">
                                <mat-icon>add</mat-icon>
                            </button>
                        </div>
                    </div>
                </div>
                
                <div class="input-container">
                    <span class="label" style="min-width: 120px;">Date Rebuild Start</span>
                    <span class="input-icon input-icon--mat cursor-pointer get-date-icon" (click)="picker.open()" matTooltip="{{ttDate}}">
                        <i class="material-icons">date_range</i>
                    </span>
                    <input type="text" [matDatepicker]="picker" class="get-Input-date"
                            placeholder="Choose a date"
                           [(ngModel)]="eventDate" 
                           readonly="readonly" style="color: black;min-width: 74px !important;width: 143px;">
                    <mat-datepicker #picker></mat-datepicker>
                </div>
        
                <!-- <div class="input-container">
                    <span class="label">Cost</span>
                    <span class="input-icon get-icon">$</span>
                    <input type="number" value="0.00" min="0" [(ngModel)]="cost"  step="any" class="get-Input-cost" />
                </div> -->
                
                <div class="margin-bottom-16">Comment</div>
                <textarea rows="4" maxlength="256" [(ngModel)]="comment"  class="textAreaComment"
                          placeholder="Enter a comment about this repair. "
                          matTooltip="{{ttComment}}"></textarea>
            </div>
            <div class="ttmodal__footer">
              <a class="button margin-right-8" (click)="onCloseClick()"><span class="button__text">Cancel</span></a>
              <!-- <a class="button button--primary" [class.loading]="savingChanges" [disabled]="StartRebuildDisabledSaveButton" (click)="saveChanges()"><span class="button__text">Save</span></a> -->
              &nbsp;&nbsp;
              <button mat-raised-button color="warn" [class.loading]="savingChanges" [disabled]="StartRebuildDisabledSaveButton" (click)="saveChanges()">
                <span class="button__text">Save</span>
              </button>
            </div>
        </mat-tab>

        <mat-tab label="Component Repaired and Replaced" *ngIf="startDate">

            <div class="ttmodal" *ngIf="componentTypes!=null">
              
                <div class="ttmodal__body">
                   
                    <div style="display: flex; flex-direction: row;">
                       
                        <div class="input-container" style="margin-bottom: 1%;">
                            <span class="label">Select Component Type</span>
                            <mat-select placeholder="Select Component Type"style="height: 40px;display: inline !important; background-color: #F4F7FA;
                            color: #1D2F36; min-height: 40px; padding: 10px; min-width: 300px;" [(ngModel)]="selectedComponentType"
                             multiple >
                                <mat-option *ngFor="let type of componentTypes" [value]="type.Id" (click)="ChangecomponentType()">
                                  {{type.Name}}
                                </mat-option>
                              </mat-select>
                        </div>
                    </div>
                    <div style="display: flex; flex-direction: column;justify-content: space-between;">
                   
                        <div class="input-container" *ngIf="equipmentId>0">
                            <span class="label" style="width: 165px;">SMU</span>
                            <input type="number"  min="0" [(ngModel)]="currentSmu" (ngModelChange)="smuChange()" step="any" style="height: 40px;
                            display: inline !important; background-color: #F4F7FA;
                            color: #1D2F36; min-height: 40px; padding: 10px;"> 
                        </div>
                
                       

                        <div class="input-container" style="margin-bottom: 16px ; margin-left: 193px;">
                            <span  class="label">Labour Hrs: {{totalHrs}}</span>
                            <span  class="label">Labour : $ {{totalLabour| number: '1.'}}</span>
                            <span  class="label">Parts : $ {{totalparts| number: '1.'}}</span>
                            <span  class="label">Misc. : $ {{totalMisc| number: '1.'}}</span>
                            <span  class="label">Total Cost: $ {{totalcost| number: '1.'}}</span>
    
    
                        </div>
                        <div style="border-radius:10px;border: solid; " [ngStyle]="{'border-color':hasDiffernce?'red':'green'}">

                        
                        <div class="input-container" style="margin-bottom: 16px ;margin-left: 17%;">
                            <span style="    margin-right: 5px;">Total Costs : </span>
                            <div style="display:flex; flex-direction: column; ">
                                <span  class="">Labour Hrs</span>
                                <input  style="min-width: 0px !important;max-width: 100px;" type="number" value="0.00" min="0" [(ngModel)]="TLabour_Hours"  step="any"
                                class="get-Input-cost" (focusout)="calculateDifferenceLabourHours()"> 
                            </div>
                            <div style="display:flex; flex-direction: column; ">
                                <span  class="">Labour $ </span>
                                <input  style="min-width: 0px !important;max-width: 100px;" type="number" value="0.00" min="0" [(ngModel)]="TLabour_Cost"  step="any"
                                class="get-Input-cost" (focusout)="calculateDifferenceLabourCost()"> 
                            </div>
                            <div style="display:flex; flex-direction: column; ">
                                <span  class="">PartCost $</span>
                                <input  style="min-width: 0px !important;max-width: 100px;" type="number" value="0.00" min="0" [(ngModel)]="TPart_Cost"  step="any"
                                class="get-Input-cost"  (focusout)="calculateDifferencePartCost()"> 
                            </div>
                            <div style="display:flex; flex-direction: column; ">
                                <span  class="">Misc. $ </span>
                                <input  style="min-width: 0px !important;max-width: 100px;" type="number" value="0.00" min="0" [(ngModel)]="TMisc_Cost"  step="any"
                                class="get-Input-cost" (focusout)="calculateDifferenceMiscCost()"> 
                            </div>
                           
                        </div>
                        <div class="input-container" style="margin-bottom: 16px ; margin-left: 17%;">
                            <span style="    margin-right: 51px;">Difference : </span>
                            <div style="display:flex; flex-direction: column; ">
                                <span  class="" style="width: 100px;" [ngStyle]="{'color':DLabour_Hours!=0?'red':'green'}"> {{DLabour_Hours}}</span>
                                
                            </div>
                            <div style="display:flex; flex-direction: column; ">
                                <span  class="" style="width: 100px;" [ngStyle]="{'color':DLabour_Cost!=0?'red':'green'}">{{DLabour_Cost}} </span>
                               
                            </div>
                            <div style="display:flex; flex-direction: column; ">
                                <span  class="" style="width: 100px;" [ngStyle]="{'color':DPart_Cost!=0?'red':'green'}">{{DPart_Cost}}</span>
                                
                            </div>
                            <div style="display:flex; flex-direction: column; ">
                                <span  class="" style="width: 100px;" [ngStyle]="{'color':DMisc_Cost!=0?'red':'green'}">{{DMisc_Cost}} </span>
                               
                            </div>
                            
                        </div>
                    </div>
                    </div>
                    <div  style="overflow-y: auto; height: 330px; padding-top: 5px;">
                    <table class="table table--striped table--full-width">
                        <thead>
                            <th style="padding-left: 20px;">
                                <mat-checkbox color="primary" [(ngModel)]="cbAllComponentSelect"
                                                        (click)="toggleAllObsevations(!cbAllComponentSelect)"
                                                        style=" margin-right: 16px!important;"></mat-checkbox>
                            </th>
                            <th>Component</th>
                            <th>Action Type</th>
                            <th>Hrs</th>
                            <th>Labour $</th>
                            <th>Parts $</th>
                            <th>Misc. $</th>
                            <th>Total</th>
                            <th>Comment</th>
                            <th>Planned</th>
                            <th></th>
                        </thead>
                        <tbody>
                            <ng-container *ngIf=" selectedComponentType?.length>0">
                                    <tr *ngFor="let comp of componentList" [ngClass]="{'ErrorAction': comp.ActionSucess==2}">
                                        <td>
                                            <mat-checkbox
                                            id="chkComponent-{{comp.Id}}"
                                            [checked]="comp.selectComp" [value]="comp.Id"
                                            style="margin-left: 16px!important; margin-right: 16px!important;"
                                            color="primary"
                                            (change)="onComponentListControlChanged(comp.Id, comp.Name,comp)">
                                        </mat-checkbox>
                                        </td>
                                        <td>{{comp.Name}}</td>
                                        <td>
                                            <mat-form-field style="max-width: 100px;">
                                              <mat-select placeholder="Select Action" [(ngModel)]="comp.ActionId" required>
                                                <mat-option [value]="1">Replace</mat-option>
                                                <mat-option [value]="2">Repair</mat-option>
                                              </mat-select>
                                            </mat-form-field>
                                          </td>
                                          <td style="min-width:0px !important;max-width: 135px!important;  padding: 1px!important;">
                                            <input  style="min-width: 0px !important;max-width: 100px;" type="number" value="0" min="0"  [(ngModel)]="comp.LabourHrs"  step="any"
                                             class="get-Input-cost" (focusout)="calculateTotalHrs()"> 
                                          </td>
                                          <td style="min-width:0px !important;max-width: 135px!important;  padding: 1px!important;">
                                            <input  style="min-width: 0px !important;max-width: 100px;" type="number" value="0.00" min="0" [(ngModel)]="comp.LabourCost"  step="any"
                                             class="get-Input-cost" (focusout)="calculateTotalCost(comp)"> 
                                          </td>
                                          <td style="min-width:0px !important;max-width: 135px!important;  padding: 1px!important;">
                                            <input  style="min-width: 0px !important;max-width: 100px;" type="number" value="0.00" min="0"   [(ngModel)]="comp.PartCost"  step="any"
                                             class="get-Input-cost" (focusout)="calculateTotalCost(comp)"> 
                                          </td>
                                          <td style="min-width:0px !important;max-width: 135px!important;  padding: 1px!important;">
                                            <input  style="min-width: 0px !important;max-width: 100px;" type="number" value="0.00" min="0"  [(ngModel)]="comp.MiscCost"  step="any"
                                             class="get-Input-cost" (focusout)="calculateTotalCost(comp)"> 
                                          </td>
                                          <td style="min-width:0px !important;max-width: 135px!important;  padding: 1px!important;">
                                            <input  style="min-width: 0px !important;max-width: 100px;" [disabled]="true" type="number" value="0.00" min="0" [(ngModel)]="comp.cost"  step="any"
                                             class="get-Input-cost" > 
                                          </td>
                                          <td>
                                            <input rows="4" maxlength="256" [(ngModel)]="comp.comment"  class="textAreaComment" style="min-width: 275px;"
                                                placeholder="Enter a comment about this repair."/>
                                          </td>
                                          <td>
                                            <mat-checkbox [(ngModel)]="comp.Planned" style="margin-left: 16px!important; margin-right: 16px!important;"
                                            color="primary">
                                            </mat-checkbox>
                                         </td>
                                          <td style="width: 17%;">
                                            <span style="color: red;">{{comp.Error}} <b>{{comp.ActionMinDate|date: 'dd MMM yyyy'}}</b></span>
                                          </td>
                                    </tr>
                            </ng-container>
                        </tbody>
                    </table>
                    </div>
                </div>
                <div class="ttmodal__footer">
                  <a class="button margin-right-8" (click)="onCloseClick()"><span class="button__text">Cancel</span></a>&nbsp;&nbsp;
                  <button mat-raised-button color="warn" [class.loading]="CompActionsavingChanges" [disabled]="DisabledSaveButton" (click)="saveChangesNewAction()">
                    <span class="button__text">Save</span>
                  </button>
                </div>
            </div>
        </mat-tab>

        <mat-tab label="Rebuild Asset Budgets" *ngIf="startDate">
            <div class="ttmodal" >
                <div class="ttmodal__body">
                 
            <div style="display: flex;">
                <div class="input-container">
                    <span class="label">Cycle No</span>
                    <span class="label">{{cycleNo}}</span>
                </div>
                <div class="input-container">
                    <span class="label">Date Rebuild Started</span>
                    <span class="input-icon input-icon--mat cursor-pointer get-date-icon">
                        <i class="material-icons">date_range</i>
                    </span>
                    <input type="text" [matDatepicker]="picker1" class="get-Input-date"
                           [(ngModel)]="startDate" 
                           readonly="readonly" style="color: black">
                    <mat-datepicker #picker1></mat-datepicker>
                </div>
            </div>
                    
                  
                    <div class="input-container">
                        <span class="label">Date Rebuild End</span>
                        <span class="input-icon input-icon--mat cursor-pointer get-date-icon" (click)="picker2.open()" >
                            <i class="material-icons">date_range</i>
                        </span>
                        <input type="text" [matDatepicker]="picker2" class="get-Input-date"
                               [min]="startDate"  placeholder="Choose a date"
                               [(ngModel)]="rebuildCompleteventDate" 
                               readonly="readonly" style="color: black">
                        <mat-datepicker #picker2></mat-datepicker>
                    </div>
                    <div style="margin-left: 10px;margin-top: 2%; ">
                        <span style="font-weight: 600;">Budgets</span>

                    </div>
                    <div style="margin-left: 9%;">
                        <div class="input-container">
                            <span class="label">Hours</span>
                            <span class="input-icon get-icon" style="width: 69px;">Hours</span>
                            <input  style="min-width: 167px !important;width: 167px;" type="number"  min="0" [(ngModel)]="hours"  step="any" class="get-Input" />
                        </div>
                        <div class="input-container">
                            <span class="label">BCM</span>
                            <span class="input-icon get-icon" style="width: 69px;">m³</span>
                            <input   style="min-width: 167px !important;width: 167px;"type="number"  min="0" [(ngModel)]="bcm"  step="any"   class="get-Input"/>
                        </div>
                        <div class="input-container">
                            <span class="label">Tonnage</span>
                            <span class="input-icon get-icon" style="width: 69px;">Tons</span>
                            <input   style="min-width: 167px !important;width: 167px;"type="number"  min="0" [(ngModel)]="tons"  step="any"   class="get-Input"/>
                        </div>
                       
                    </div>
                   
                    
                    <div class="margin-bottom-16">Comment</div>
                    <textarea style="border: solid;border-color: #615a5a;"  rows="4" maxlength="256" [(ngModel)]="rebuildCompletcomment"  class="textAreaComment"
                              placeholder="Enter a comment about this Rebuild Completion. "
                             ></textarea> 
                </div>
                <div class="ttmodal__footer">
                  <a class="button margin-right-8" (click)="onCloseClick()"><span class="button__text">Cancel</span></a>&nbsp;&nbsp;
                  <a class="button button--primary" [class.loading]="rebuildCompletesavingChanges" (click)="saveChangesRebuildComplete()"><span class="button__text">Save</span></a>
                </div>
            </div>
        </mat-tab>
    </mat-tab-group>
    
</div>
